import { axios } from '~/clients';
import { RECALL_STATUS } from '~/constants/endpoints';
import type { Recall } from '~/contracts/vdp';

export default function fetchRecalls(
  vehicleId: number,
  controller: AbortController
) {
  return axios.get<Recall[]>(`${RECALL_STATUS}?vehicleId=${vehicleId}`, {
    signal: controller.signal
  });
}
